const styles = {
  card: {
    width: 900,
  },
  closeIcon: {
    float: 'right !important',
    cursor: 'pointer',
    background: 'darkgray !important',
    borderRadius: '50% !important',
    boxShadow: '10px 10px 50px gray !important',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
  },
  actionsButtonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
};

export default styles;
